import camelcaseKeys from 'camelcase-keys';

import { formatToRequestParameter } from 'utils/formatting';
import apiGateway from '../axios';

import { IGetSurvey } from 'apis/survey/type';
import { IRequestVideo, IRequestAssignment } from './type';

// 핵심간호술기영상 저장
export const getVideo = (request: IGetSurvey) => {
  const url = `/file/video?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const deleteVideo = (request: IRequestVideo) => {
  const url = `/file/video_delete`;
  return apiGateway.post(url, camelcaseKeys(request));
};

// 핵심간호술기영상 저장
export const getAssignment = (request: IGetSurvey) => {
  const url = `/file/assignment?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const deleteAssignment = (request: IRequestAssignment) => {
  const url = `/file/assignment_delete`;
  return apiGateway.post(url, camelcaseKeys(request));
};
